// src/components/registration/RegistrationHeader.tsx
import {
  Card,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";

interface RegistrationHeaderProps {
  collegeName: string;
}

export function RegistrationHeader({ collegeName }: RegistrationHeaderProps) {
  return (
    <Card className="mb-6">
      <CardHeader>
        <CardTitle>Candidate Registration - {collegeName}</CardTitle>
        <CardDescription>
          Please fill in your details below. All fields marked with * are
          required.
        </CardDescription>
      </CardHeader>
    </Card>
  );
}
